import { useEffect, useMemo, useState } from "react";
import { Modal } from "react-bootstrap";
import { useSelector } from "react-redux";
import GmailComposeModal from "../../InboxTab/GmailComposeModal";
import useInbox from "../../InboxTab/InboxContext";
import EmailBulkActions from "../EmailBulkActions";
import EAddProject from "../../ArtworkTab/EAddProject";

export default function EmailDetailHeader({
  message,
  setMessage,
  refreshFunc,
  viewEmail = false,
}) {
  /* ******************** All States ************************* */
  const user = useSelector((state) => state.user.userInfo);
  const {
    messageId,
    setMessageId,

    emailsHistoryList: emails,
    setEmailsHistoryList,
  } = useInbox();
  const [showGmailComposeModal, setShowGmailComposeModal] = useState(false);
  const [showComposeModal, setShowComposeModal] = useState(false);

  const [replyToEmail, setReplyToEmail] = useState(null);

  const [showForwardModal, setShowForwardModal] = useState(false);
  const [forwardEmail, setForwardEmail] = useState(null);

  const [messageIdToUse, setMessageIdToUse] = useState(null);
  const [showAddProjectModal, setShowAddProjectModal] = useState(false);

  /* ******************** All Functions ************************* */

  const updateMessageId = (id) => {
    setMessageIdToUse(id);
    setMessageId(id);
    setMessageId(id);
  };

  const handleReply = (email) => {
    setReplyToEmail(email);
    setShowComposeModal(true);
  };

  const handleForward = (email) => {
    setForwardEmail(email);
    setShowForwardModal(true);
  };

  const handlePreviousEmail = () => {
    let currentIndex = emails.findIndex((email) => email.id === messageIdToUse);
    if (currentIndex > 0) {
      let previousEmail = emails[currentIndex - 1];
      updateMessageId(previousEmail.id);
    }
  };

  const handleNextEmail = () => {
    let currentIndex = emails.findIndex((email) => email.id === messageIdToUse);
    if (currentIndex < emails.length - 1) {
      let nextEmail = emails[currentIndex + 1];
      updateMessageId(nextEmail.id);
    }
  };

  const projectInitialData = useMemo(() => {
    const collectEmails = (items) =>
      Array.isArray(items)
        ? items
            .map((item) => (item?.email || "").trim())
            .filter((email) => email.length > 0)
        : [];

    const teamMembers = Array.from(
      new Set([
        ...collectEmails(message?.from),
        ...collectEmails(message?.to),
        ...collectEmails(message?.replyTo),
      ]),
    );

    return {
      name: message?.subject || "",
      artworkId: "",
      status: "pending",
      teamMembers,
    };
  }, [message]);

  /* ******************** All UseEffects ************************* */

  useEffect(() => {
    setMessageIdToUse(messageId || messageId);
  }, [messageId, messageId]);

  // useEffect(() => {
  //   console.log(emails);
  // }, [emails]);

  return (
    <div>
      {/* ******************** Header Actions ************************* */}
      <div className="row">
        {/* ====== Left Side Header */}
        <div
          className="col-1 align-items-center d-flex"
          style={{
            width: 50,
          }}
        >
          <button onClick={() => updateMessageId(null)} className="btn btn-sm">
            <i className="mdi mdi-arrow-left fs-4 "></i>
          </button>
        </div>
        {/* ====== Right Side Header */}
        <div className="col-11 ">
          <div className="d-flex justify-content-between align-items-center px-1">
            <div className="w-50 d-flex align-items-center gap-3">
              <EmailBulkActions refreshFunc={refreshFunc} />
              <div className="d-flex align-items-center gap-3">
                {/* reply */}
                <button
                  title="Reply"
                  className="btn btn-sm border-0 px-0"
                  onClick={() => handleReply(message)}
                >
                  <i
                    style={{
                      fontSize: "23px",
                      width: "23px",
                    }}
                    className="flex-center p-0 mdi mdi-reply"
                  ></i>
                </button>
                {/* forward */}
                <button
                  title="Forward"
                  className="btn btn-sm border-0 px-0"
                  onClick={() => handleForward(message)}
                >
                  <i
                    style={{
                      fontSize: "23px",
                      width: "23px",
                    }}
                    className="flex-center p-0 mdi mdi-share"
                  ></i>
                </button>
              </div>
              {/* Create Project */}
              <button
                title="Create Project"
                className="btn btn-sm  py-0 btn-outline-secondary d-flex align-items-center gap-1"
                onClick={() => setShowAddProjectModal(true)}
              >
                <i
                  style={{
                    fontSize: "23px",
                    width: "23px",
                  }}
                  className="flex-center p-0 mdi mdi-plus"
                ></i>
                Create Project
              </button>
            </div>
            <div className="d-flex align-items-center justify-content-end gap-2">
              <div>
                <button
                  onClick={(e) => {
                    // refreshFunc(messageIdToUse);
                    refreshFunc(messageIdToUse);
                  }}
                  title="Refresh"
                  className="btn btn-sm border-0 px-1"
                >
                  <i
                    style={{
                      fontSize: "23px",
                      width: "23px",
                    }}
                    className="flex-center mdi mdi-refresh "
                  ></i>
                </button>
                {!viewEmail && (
                  <>
                    <button
                      title="Previous Email"
                      className="btn btn-sm px-1 border-0"
                      onClick={handlePreviousEmail}
                      disabled={
                        emails.findIndex(
                          (email) => email.id === messageIdToUse,
                        ) === 0
                      }
                    >
                      <i className="mdi mdi-chevron-left fs-3 py-0"></i>
                    </button>
                    <button
                      title="Next Email"
                      className="btn btn-sm px-1 border-0"
                      onClick={handleNextEmail}
                      disabled={
                        emails.findIndex(
                          (email) => email.id === messageIdToUse,
                        ) ===
                        emails.length - 1
                      }
                    >
                      <i className="mdi mdi-chevron-right fs-3 py-0"></i>
                    </button>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
        {/* Compose Modals */}
        {replyToEmail && replyToEmail?.id && (
          <GmailComposeModal
            show={showComposeModal}
            replyTo={true}
            setShow={setShowComposeModal}
            refreshFunc={refreshFunc}
            message={replyToEmail}
            replyToMessageId={replyToEmail.id}
            closeFunc={() => {
              setReplyToEmail(null);
            }}
          />
        )}

        {forwardEmail && (
          <GmailComposeModal
            show={showForwardModal}
            setShow={setShowForwardModal}
            refreshFunc={refreshFunc}
            message={{
              ...forwardEmail,
              from: "",
              forwardFrom: forwardEmail.from,
              subject: forwardEmail.subject?.startsWith("Fwd:")
                ? forwardEmail.subject
                : `Fwd: ${forwardEmail.subject || ""}`,
            }}
            forwardAttachments={forwardEmail.attachments || []}
            forwardEmail={Boolean(forwardEmail)}
            closeFunc={() => {
              setForwardEmail(null);
            }}
          />
        )}
        <GmailComposeModal
          show={showGmailComposeModal}
          setShow={setShowGmailComposeModal}
        />
        <Modal
          show={showAddProjectModal}
          onHide={() => setShowAddProjectModal(false)}
          centered
          style={{ zIndex: 9999999 }}
          contentClassName="shadow-lg"
        >
          <EAddProject
            show={showAddProjectModal}
            hideModal={() => setShowAddProjectModal(false)}
            initialData={projectInitialData}
            onSaved={() => {
              setShowAddProjectModal(false);
            }}
          />
        </Modal>
      </div>
    </div>
  );
}
